import React, { memo } from "react";

import { transformDateToLocalDateString } from "helpers";
import { ShowcaseCard, ShowcaseNotice } from "ui/components/Showcase";
import {
  getVehicleImage,
  getVehicleName,
} from "ui/modules/fleet/vehicles/pages/VehicleDetailPage/components/VehicleDetailCard/components/VehicleEditCard/components/VehicleWizardIntro/helpers";

import { RESIDUAL_VALUE_INTRO_SAMPLE } from "../consts";
import { ResidualValueSceneProps } from "../types";

/** Korak "Osnovni podaci": vozilo iz kataloga s JOM oznakom i datum od kojeg se računa. */
const ResidualValueBasicScene: React.FC<ResidualValueSceneProps> = ({ formValues, vehicleInfo }) => {
  const priceDate = transformDateToLocalDateString(formValues.priceOnDate ?? new Date());

  return (
    <>
      <ShowcaseCard className="left-[0.5rem] top-[-1rem] w-[17rem] h-[18rem]" delay={0}>
        <div className="p-5">
          {/* Slika vozila ima širok prozirni rub, pa se uvećava unutar okvira da auto ispuni karticu. */}
          <div className="h-[9rem] overflow-hidden">
            <img src={getVehicleImage(vehicleInfo)} alt="" className="w-full h-full object-contain scale-[1.4]" />
          </div>

          <div className="mt-3 text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">
            {formValues.jom ? `JOM ${formValues.jom}` : RESIDUAL_VALUE_INTRO_SAMPLE.jom}
          </div>
          <div className="text-sm font-bold text-slate-800 truncate">{getVehicleName(vehicleInfo)}</div>
          {vehicleInfo.vehicleTypeName && (
            <div className="text-[0.65rem] text-slate-400 truncate">{vehicleInfo.vehicleTypeName}</div>
          )}
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="right-[-0.5rem] top-[6rem] w-[14rem]" delay={0.25}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Cijena na dan</div>
          <div className="mt-2 text-sm font-bold text-slate-800">{priceDate}</div>
          <div className="mt-3 inline-flex px-2 py-0.5 rounded-full text-[0.65rem] font-semibold bg-blue-100 text-blue-700">
            Katalog CVH
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="left-[-1.5rem] bottom-[-0.5rem] w-[15rem]" delay={0.5}>
        <ShowcaseNotice
          title="Otkupna i prodajna vrijednost"
          subtitle="Obje u jednom izračunu"
          iconClassName="bg-blue-100"
          icon={
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#1D4ED8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M7 16V4m0 0L3 8m4-4l4 4M17 8v12m0 0l4-4m-4 4l-4-4" />
            </svg>
          }
        />
      </ShowcaseCard>
    </>
  );
};

export default memo(ResidualValueBasicScene);
